import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Quote } from 'lucide-react';
import { getTestimonyBySlug } from '../data/testimonies';
export function TestimonyDetailPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const testimony = slug ? getTestimonyBySlug(slug) : undefined;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!testimony) {
    return <main className="flex-grow pt-32 pb-24 bg-ivory text-center px-6" data-id="element-618" data-mp="15mm9t1m641h2">
        <h1 className="text-4xl font-display font-bold text-midnight mb-6" data-id="element-619" data-mp="10pcgvbzkl7oh">
          Testimony not found
        </h1>
        <Link to="/impact" className="inline-flex items-center gap-2 text-gold font-bold tracking-wide hover:text-midnight transition-colors" data-id="element-620" data-mp="1enke7l0iqb06">
          <ArrowLeft className="w-5 h-5" data-id="element-621" data-mp="3gffcmyxrkj0g" /> Back to Testimonies
        </Link>
      </main>;
  }
  return <main className="flex-grow pt-24" data-id="element-622" data-mp="3cf59rv59q8pt">
      <div className="bg-midnight text-ivory py-24 relative overflow-hidden" data-id="element-623" data-mp="3cg6l80q74x82">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-624" data-mp="ajzq80ylcb3g" />

        <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-625" data-mp="kgup4kys0di9">
          <Link to="/impact" className="inline-flex items-center gap-2 text-ivory/70 hover:text-gold transition-colors text-sm font-bold tracking-widest uppercase mb-12" data-id="element-626" data-mp="kf9w4zs412mi">
            <ArrowLeft className="w-4 h-4" data-id="element-627" data-mp="u6e9xw61uhfr" /> All Testimonies
          </Link>

          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-628" data-mp="y6y4crz8n6y7">
            Testimony
          </div>

          <h1 className="text-4xl md:text-6xl font-display font-bold leading-tight tracking-tighter mb-8" data-id="element-629" data-mp="185dxt1lqmsav">
            {testimony.title}
          </h1>

          <p className="text-ivory/70 text-sm font-bold uppercase tracking-wider" data-id="element-630" data-mp="39xsc7qp2pemj">
            — {testimony.name}
          </p>
        </div>
      </div>

      <section className="py-32 bg-ivory text-midnight" data-id="element-631" data-mp="31xvtc2ky2k1e">
        <div className="max-w-3xl mx-auto px-6" data-id="element-632" data-mp="2xvsd70nbyr9s">
          <article className="bg-white p-8 md:p-16 rounded-[3rem] shadow-xl border-2 border-midnight/5 relative overflow-hidden" data-id="element-633" data-mp="2xx3jb7490b42">
            <Quote className="absolute -top-10 -right-10 w-48 h-48 text-gold opacity-10 pointer-events-none" data-id="element-634" data-mp="3bsxiuzj4to4i" />

            <div className="w-16 h-2 bg-gold rounded-full mb-12 relative z-10" data-id="element-635" data-mp="3kvyjikp8an0s" />

            <div className="font-medium leading-relaxed text-lg md:text-xl text-charcoal/80 space-y-8 relative z-10" data-id="element-636" data-mp="3ktlujnl1zce8">
              {testimony.paragraphs.map((p, i) => <p key={i} data-id="element-637" data-mp="3ul9vcf3i25sd" data-mpi={i}>{p}</p>)}
            </div>

            <div className="mt-16 pt-8 border-t-2 border-midnight/5 relative z-10" data-id="element-638" data-mp="3pmf18h030usy">
              <p className="font-display font-bold text-2xl text-midnight" data-id="element-639" data-mp="8e1sbjg1yazi">
                {testimony.name}
              </p>
            </div>
          </article>

          <div className="mt-16 text-center" data-id="element-640" data-mp="3ddtibll0puq">
            <Link to="/impact" className="inline-flex items-center gap-2 text-midnight font-bold tracking-wide hover:text-gold transition-colors" data-id="element-641" data-mp="n10jddazz3dp">
              <ArrowLeft className="w-5 h-5" data-id="element-642" data-mp="d3m2xdp2qele" /> Back to all testimonies
            </Link>
          </div>
        </div>
      </section>
    </main>;
}